import { createContext } from "react";

export const completeData = createContext({})